export class Mark {
    parent;
    constructor({ app, markDate, markName }) {
        this.parent = app;
        this.markDate = markDate || app.appClock.currentDate;
        this.markName = markName;
        this.markAnswerId = app.answerId;
    }
    get app() {
        return this.parent;
    }
    markDate;
    markName;
    markAnswerId;
}
